module.exports = __webpack_public_path__ + "static/assets/f31485f878889cec847f58e80a47e9ed.png";